import { Link } from "react-router-dom";
import { Reveal, Eyebrow, LineReveal } from "../components/motion";
import { IMAGES } from "../config/site";

export default function Weddings() {
  return (
    <>
      <section className="relative h-[72svh] min-h-[520px] overflow-hidden flex items-end" data-testid="weddings-hero">
        <div className="absolute inset-0">
          <img src={IMAGES.harvest} alt="Lavender rows at golden hour" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-ink/40" />
        </div>
        <div className="relative z-10 max-w-6xl mx-auto w-full px-6 md:px-8 pb-16">
          <Eyebrow className="mb-6">Weddings & Events</Eyebrow>
          <LineReveal lines={["Say it in", "the high country."]} className="display-1 text-cream" />
        </div>
      </section>

      <section className="py-24 md:py-32 px-6 md:px-16" data-testid="weddings-intro-section">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <Reveal>
              <h2 className="display-2 text-cream">
                A small gathering, <span className="serif-italic text-lavglow">a big landscape.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-sage mt-8 leading-relaxed text-sm md:text-base max-w-xl">
                Imagine your people gathered in the valley — mountain views, lavender in season,
                horses in the paddocks and a long slow dusk. Our domes give your closest guests a
                place to stay, and the high country gives the day its atmosphere.
              </p>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="text-fern mt-5 leading-relaxed text-sm md:text-base max-w-xl">
                Every celebration is different, so tell us what you're dreaming of and we'll
                talk it through — from intimate ceremonies to quiet celebrations on the farm.
              </p>
            </Reveal>
            <Reveal delay={0.22}>
              <Link to="/contact" className="btn-primary mt-10" data-testid="weddings-enquire-button">
                Enquire about your day
              </Link>
            </Reveal>
          </div>
          <div className="lg:col-span-5 grid gap-4">
            <Reveal y={40}>
              <div className="img-frame aspect-[4/3]">
                <img src={IMAGES.horses} alt="Horses grazing on the farm" className="h-full w-full object-cover" />
              </div>
            </Reveal>
            <Reveal y={40} delay={0.1}>
              <div className="img-frame aspect-[4/3]">
                <img src={IMAGES.lavender} alt="Lavender field path" className="h-full w-full object-cover" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
